// @ts-check

import { load } from '../App'

/**
 * @typedef {Object} InlineExtraOptions
 * @property {HTMLElement} node
 * @property {import('../App').Loading=} loading
 */

/**
 * @typedef {import("../App").LoadStyleOptions & InlineExtraOptions} InlineOptions
 */

/**
 * Embeds a dot.vu Page in an inline fashion.
 */
class Inline {
  /** @type {import("../App").EmbedOptions} */
  _embedOptions

  /** @type {InlineOptions} */
  _options

  /**
   * @param {import("../App").EmbedOptions} embedOptions
   * @param {InlineOptions} options
   */
  constructor(embedOptions, options) {
    this._embedOptions = embedOptions
    this._options = options
  }

  /**
   * @param {((page: import('../Page').Page) => any)=} cb
   */
  load(cb) {
    load(
      this._options.node,
      Object.assign({}, this._embedOptions, this._options, {
        loading: this._options.loading || 'off',
      }),
      cb
    )
  }
}

export { Inline }
